const _API_URL = {
    HOST: process.env.REACT_APP_API_URL || "https://api.nhanam.updates.com.vn",
    HOST_UPLOAD: process.env.REACT_APP_AUDIO_API_URL || "https://omni.dinhmanhhung.net",
    HOST_UPLOAD_VOICE: process.env.REACT_APP_AUDIO_API_URL || "https://omni.dinhmanhhung.net",
    IMAGE_URL: `${process.env.REACT_APP_API_URL || "https://api.nhanam.updates.com.vn"}/images`,
    LOGIN: "auth/login",
    REGISTER: "admins/register",
    REFRESH_TOKEN: "admins/refreshtoken",
    GET_USER_INFO: "users/my_profile",
    GET_LIST_BOOK: "books",
    GET_TOTAL_BOOK: "books/count",
    CREATE_BOOK: "books",
    GET_LIST_CATEGORY: "category",
    GET_LIST_AUTHOR: "authors",
    GET_LIST_PUBLISHER: "publishing-houses",
    DETAIL_BOOK: "books",
    EDIT_BOOK: "books",
    DELETE_BOOK: "books",
    ADD_CATEGORY: "category",
    ADD_AUTHOR: "authors",
    ADD_PUBLISHER: "publishing-houses",
    GET_LIST_USER: "users",
    GET_LIST_STAFF: "admins/list-staff",
    GET_HISTORY: "admins/history",
    GET_CATEGORY: "category",
    GET_AUTHOR: "authors",
    GET_PUBLISHER: "publishing-houses",
    EDIT_CATEGORY: "category",
    EDIT_AUTHOR: "authors",
    EDIT_PUBLISHER: "publishers",
    DELETE_CATEGORY: "category",
    DELETE_AUTHOR: "authors",
    DELETE_PUBLISHER: "publishers",
    DELETE_STAFF: "admins",
    SET_STATUS_USER: "admins/set-status",
    GET_STATISTIC_USER: "users",
    CHANGE_PASSWORD: "admins/changepassword",
    FORGOT_PASSWORD: "admins/rs-password",
    FG_PASSWORD: "admins/forgot-password",
    GET_ALL_ORDER: "admins/all-order",
    GET_DETAIL_ORDER: "admins/detail-order",
    TOP_BOOK_BESTSELLER: "admins/book-bestseller",
    GET_STATISTIC_OVERVIEW: "admins/overview",
    GET_STATISTIC_DAY: "admins/overview-statistic-day",
    GET_STATISTIC_MONTH: "admins/overview-statistic-month",
    GET_STATISTIC_YEAR: "admins/overview-statistic-year",

    GET_ALL_PRIMARY_VOICE: "list-voices",
    GET_ALL_SECONDARY_VOICE: "all-voice-svc",
    POST_SECONDARY_VOICE: "upload-audio-svc",
    TRAING_SECONDARY_VOICE: "train-model-audio-convert-svc",

    GET_ALL_TRANSLATOR: "translator",
    ADD_TRANSLATOR: "translator",
    EDIT_TRANSLATOR: "translator",
    DELETE_TRANSLATOR: "translator",
    GET_TRANSLATOR_DETAIL: "translator",

    GET_ALL_COLLECTION: "collection",
    ADD_COLLECTION: "collection",
    ADD_THUMBNAIL_COLLECTION: "collection/upload-thumbnail",

    GET_ALL_NOTIFICATIONS: "notifications",
    CREATE_NOTIFICATION: "notifications",
    UPDATE_NOTIFICATION: "notifications",
    DELETE_NOTIFICATION: "notifications",
    SEND_NOTIFICATION: "notifications/send",
    GET_NOTIFICATION_STATS: "notifications/stats",
    GET_NOTIFICATION_TEMPLATES: "notifications/templates",
    CREATE_NOTIFICATION_TEMPLATE: "notifications/templates",
    UPDATE_NOTIFICATION_TEMPLATE: "notifications/templates",
    DELETE_NOTIFICATION_TEMPLATE: "notifications/templates",
    GET_USER_DEVICE_TOKENS: "notifications/device-tokens",
    SEND_TEST_NOTIFICATION: "notifications/test",

    HOME_LAYOUT_SECTIONS: "home-layout/sections",
    HOME_LAYOUT_ORDER: "home-layout/order",
    HOME_LAYOUT_INITIALIZE: "home-layout/initialize",
    HOME_LAYOUT_PUBLIC: "home-layout/layout",
} as const;

export const API_URL: typeof _API_URL = _API_URL;
